import { render } from "./menuChildren.vue?vue&type=template&id=5d7b143a"
import script from "./menuChildren.vue?vue&type=script&lang=js"
export * from "./menuChildren.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Work\\Lu\\_pz\\pzvtour\\pzvtour-userbackend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__